import * as SelectableSegmentDesktop from './Desktop/SelectableSegment.css';
import * as SelectableSegmentMobile from './Mobile/SelectableSegment.css';

export default {
	SelectableSegmentDesktop,
	SelectableSegmentMobile
};
